import { Card, CardContent, SxProps } from '@mui/material'
import React from 'react'

function BlockContainer({ children, sx }: { children: React.ReactNode, sx?: SxProps }) {
    return (
        <Card sx={sx}>
            <CardContent>
                {children}
            </CardContent>
        </Card>
    )
}

export default BlockContainer